// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"sharelead_tooltip__2gTbP","tooltiptext":"sharelead_tooltiptext__15ZE4"};